import { getPromptArticlesQuery } from 'src/components/PromptArticlesSectionContainer/queries/getPromptArticlesQuery';
import { useT2Query } from 'src/hooks/useT2Query';
import { Article } from 't2-graphql-types';
import { PROMPT_REPLIES_PAGE_SIZE } from '../constants';

type TData = {
  article: Article;
};

type TVariables = {
  type: 'ARTICLE';
  promptId: string;
  skip: number;
  take: number;
};

export const usePromptArticlesQuery = ({ promptId = '', skip = 0, take = PROMPT_REPLIES_PAGE_SIZE }) =>
  useT2Query<TData, TVariables>(getPromptArticlesQuery, { variables: { promptId, skip, take, type: 'ARTICLE' } });
